import React from 'react';

const Check = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="490"
    height="490"
    viewBox="0 0 16 16">
    <path fill="#E1EBF0" fillRule="evenodd" d="M15.272 2.96l.079.077.071.082c.385.473.31 1.201-.185 1.605l-9.441 7.68c-.401.325-.977.35-1.407.067-.135-.082-.236-.17-.321-.274L.59 7.923l-.066-.09c-.303-.456-.24-1.071.153-1.458L.759 6.3c.506-.411 1.263-.333 1.672.17L5.2 9.872l8.534-6.943c.451-.367 1.11-.345 1.537.03z"/>
  </svg>

);

export default Check;
